module.exports = __webpack_public_path__ + "img/gw_twwt.c1358a23.png";